import { Link, useLocation } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { COMPANY, PHONE_LINK, WHATSAPP_LINK } from "../../lib/constants";
import { trackEvent } from "../../lib/api";
import { quoteHref } from "../../data/homeContent";

export const QuoteButton = ({ location, onderwerp, params, className = "", label = "Ontvang vrijblijvend een prijsindicatie" }) => {
  const { pathname } = useLocation();
  return (
    <Link to={quoteHref(onderwerp, params)} state={{ from: pathname }} onClick={() => trackEvent("cta_quote_click", { location })}
      data-testid={`${location}-quote-cta`} className={`btn-cta group ${className}`}>
      {label}
      <ArrowRight className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
    </Link>
  );
};

export const WhatsAppButton = ({ location, dark = false, className = "", label = "Stel uw vraag via WhatsApp" }) => (
  <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer"
    onClick={() => trackEvent("click_whatsapp", { page_type: location })}
    data-testid={`${location}-whatsapp-cta`} className={`${dark ? "btn-secondary-dark" : "btn-secondary"} whitespace-nowrap ${className}`}>
    <MessageCircle className={`h-5 w-5 shrink-0 ${dark ? "text-[#4ADE80]" : "text-whatsapp"}`} aria-hidden="true" /> {label}
  </a>
);

export const PhoneLink = ({ location, dark = false }) => (
  <a href={PHONE_LINK} onClick={() => trackEvent("click_phone", { page_type: location })} data-testid={`${location}-phone-link`}
    className={`inline-flex items-center gap-1.5 whitespace-nowrap text-[14px] ${dark ? "text-slate-300 hover:text-white" : "text-slate-600 hover:text-maas"}`}>
    <Phone className="h-4 w-4" aria-hidden="true" /> Liever bellen?
    <span className={`font-semibold underline underline-offset-4 ${dark ? "text-white" : "text-ink"}`}>{COMPANY.phoneDisplay}</span>
  </a>
);

export const SectionHeading = ({ id, eyebrow, title, lead, dark = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && <p className={`eyebrow ${dark ? "!text-[#D9B97A]" : ""}`}>{eyebrow}</p>}
    <h2 id={id} className={`h2 mt-3 text-balance ${dark ? "!text-white" : ""}`}>{title}</h2>
    {lead && <p className={`lead mt-4 ${dark ? "!text-slate-300" : ""}`}>{lead}</p>}
  </div>
);
